import React from "react";
import { size } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { TopIconButton } from "../../icons/IconContainer";
import { DownloadFolderIcon } from "../../icons/DownloadFolderIcon";
import { showForm } from "../../store/formSlice";


const DownloadsButtonContainer = () => {
    const dispatch = useDispatch();
    const { selectedItems } = useSelector(state => state.data);

    return size(selectedItems)
        ? <TopIconButton onClick={() => dispatch(showForm("downloads"))}>
            <DownloadFolderIcon color="var(--sp-main-color)" />
        </TopIconButton>
        : null
};

export { DownloadsButtonContainer };